'use es6';

import quickFetch from 'quick-fetch';

/**
 * Public EarlyRequester
 *
 * This is bundled separately and included in the head of the public
 * achievements page. It attempts to pre-fetch the achievement data.
 */
import { URL_PATTERN } from './constants/AchievementConstants';
const makeEarlyRequest = endpoint => quickFetch.makeEarlyRequest(endpoint, {
  url: quickFetch.getApiUrl(endpoint, true),
  dataType: 'json',
  contentType: 'application/json',
  type: 'GET',
  noPortalId: true
});
const [__, publicId] = window.location.pathname.match(URL_PATTERN) || [];
if (publicId) {
  // In public achievements app context
  // Request public data for this achievement
  makeEarlyRequest(`/academy/learning-center/progress/v1/achievements/public/${publicId}`);
}